import React from 'react'

const urls = {
  youtube: {
    api: `https://www.googleapis.com/youtube/v3/videos?id={0}&key=${process.env.YOUTUBE_API_KEY}&fields=items(snippet(title))&part=snippet`,
  },
}

class CustomPlyr extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      plyr: null,
    }
  }

  componentDidMount() {
    import(/* webpackChunkName: "react-plyr" */ 'react-plyr-ssr')
      .then(({ default: plyr }) => {
        this.setState({ plyr })
      })
      .catch((err) => {
        console.log('failed', err)
      })
  }

  render() {
    if (typeof window === `undefined`) {
      return null
    }

    const Plyr = this.state.plyr
    if (!Plyr) {
      return null
    }
    return (
      <Plyr
        ref={this.props.innerRef}
        urls={urls}
        {...this.props}
      />
    )
  }
}

export default React.forwardRef(
  (props, ref) => <CustomPlyr innerRef={ref} {...props} />)
